export default {
  survey_answers: {
    Survey_PriceVisit_Very_Correct: 'ausgezeichnet',
    Survey_PriceVisit_Correct: 'sehr gut',
    Survey_PriceVisit_High: 'hoch',
    Survey_WithWhom_Couple: 'als Paar',
    Survey_WithWhom_Family: 'mit der Familie',
    Survey_WithWhom_Friends: 'mit Freunden',
    Survey_WithWhom_Other: 'andere',
    Survey_WithWhom_Group: 'mit einer Reisegruppe',
    Survey_WithWhom_Solo: 'alleine',
    Survey_FirstVisit_NoCameOnce: 'Nein, ich war schon einmal hier.',
    Survey_FirstVisit_NoCameSeveralTimes: 'Nein, ich war hier schon öfter.',
    Survey_WithWhom_FamilyUnder18: 'Mit der Familie (mit Minderjährigen)',
    Survey_WithWhom_FamilyNoUnder18: 'Mit der Familie (ohne Minderjährige)',
    ja: 'ja',
    nein: 'nein',
    Yes: 'Ja',
    No: 'Nein',
    Survey_Maybe: 'Vielleicht',
    Survey_HistoPadUserFriendly_YesIntuitive: 'Absolut - überhaupt kein Problem!',
    Survey_HistoPadUserFriendly_YesOk: 'Ja, es ist ok.',
    Survey_Origin_ForeignCountry: 'Ausland',
    Survey_Origin_France: 'Deutschland',
    Survey_Reside_Answer_HautesPyrenees: 'Sachsen',
    Survey_Reside_Answer_HauteGaronne: 'Hautes-Garonne',
    Survey_Reside_Answer_PyreneesAtlantique: 'Pyrénées-Atlantique',
    Survey_Reside_Answer_Gers: 'Gers',
    Survey_Reside_Answer_Other: 'Somewhere else',
    Survey_ResideHautesPyrenees_Answer_Campan: 'The Campan valley (La Mongie, Bagnères de Bigorre)',
    Survey_ResideHautesPyrenees_Answer_Gavarnie: 'The Gavarnie valley (Barèges, Luz, Gavarnie)',
    Survey_ResideHautesPyrenees_Answer_Gaves: 'The Gaves valley (Cauterets, Argelès, Val d’Azun)',
    Survey_ResideHautesPyrenees_Answer_AureLouron: 'The Aure and Luron valley (St Lary, Arreau)',
    Survey_ResideHautesPyrenees_Answer_Lourdes: 'Lourdes',
    Survey_ResideHautesPyrenees_Answer_Other: 'Somewhere else in Hautes-Pyrénées',
    Survey_ResideHauteGaronne_Answer_Luchon: 'Luchon',
    Survey_ResideHauteGaronne_Answer_Other: 'Somewhere else in Haute-Garonne',
    Survey_Income_Answer_LessThan1500: 'weniger als 1500 €',
    Survey_Income_Answer_1500To3000: '1500 bis 3000 €',
    Survey_Income_Answer_3000To4500: '3000 bis 4500 €',
    Survey_Income_Answer_4500To6000: '4500 bis 6000 €',
    Survey_Income_Answer_MoreThan6000: 'mehr als 6000 €',
    Survey_Income_Answer_NoAnswer: 'Ich möchte nicht antworten.',
    Survey_Planetarium_Answer_Yes: 'ja',
    Survey_Planetarium_Answer_No: 'nein',
    Survey_SeanceCoupole_Answer_Yes: 'Yes',
    Survey_SeanceCoupole_Answer_No: 'No',
    Survey_HearAboutSite_WordMouth: 'Mundpropaganda',
    Survey_HearAboutSite_Report: 'Report (Television/Radio/Newspaper…)',
    Survey_HearAboutSite_Internet: 'Internet',
    Survey_HearAboutSite_Flyer: 'Prospekt',
    Survey_HearAboutSite_Advertisment: 'Advertisement (Display/Radio/Voucher…)',
    Survey_HearAboutSite_Other: 'andere',
    Survey_HearAboutExhibit_Television: 'Fernseher',
    Survey_HearAboutExhibit_Radio: 'Radio',
    Survey_HearAboutExhibit_Digital: 'Digital (Mobile/Online)',
    Survey_HearAboutExhibit_WordOfMouth: 'Mundpropaganda',
    Survey_HearAboutExhibit_Print: 'Print (Newspaper/Magazine)',
    Survey_HearAboutExhibit_Other: 'Andere',
    Survey_HearAboutExhibit_Advertisment: 'Werbung',
    Survey_HearAboutExhibit_Report: 'Bericht',
    Survey_HearAboutExhibit_Internet: 'Internet',
    Survey_Gender_Male: 'männlich',
    Survey_Gender_Female: 'weiblich',
    Fernsehen: 'Television',
    Radio: 'Radio',
    Survey_RentingPrice_JustRight: 'Genau richtig',
    Survey_RentingPrice_TooLow: 'Zu niedrig',
    Survey_RentingPrice_TooHigh: 'Zu hoch',
    Others: 'Andere Antworten',
    Survey_VisitPrice_VeryCorrect: 'Sehr angemessen',
    Survey_VisitPrice_Correct: 'Fair',
    Survey_VisitPrice_High: 'Hoch',
    Survey_WithWhom_GroupTwentyMore: 'Als Gruppe (20 Personen und mehr)',
    Survey_Coming_WordMouth: 'Mundpropaganda',
    Survey_Coming_TravelGuide: 'Reiseleiter',
    Survey_Coming_CastleWebsite: 'Website des Schlosses',
    Survey_Coming_CastleFlyer: 'Broschüre des Schlosses',
    Survey_Coming_CastleActivity: 'Vor-Ort-Angebote',
    Survey_Coming_TouristOffice: 'Fremdenverkehrszentrale',
    Survey_Coming_AdvertDisplay: 'Werbeanzeige',
    Survey_Coming_Media: 'Medien (Fernsehen.Radio.Artikel…)',
    Survey_Transportation_Car: 'Mit dem Auto',
    Survey_Transportation_Bus: 'Mit dem Bus',
    Survey_Transportation_NavetteRemi: 'By bus-shuttle château Rémi',
    Survey_Transportation_Bicycle: 'Mit dem Fahrrad',
    Survey_VisitPrice_Correct_Meissen: 'Angemessen',
    Survey_VisitPrice_High_Meissen: 'Zu hoch',
    Survey_HearAboutSite_WordMouth_Meissen: 'Empfehlung von Freunden/ Bekannten',
    Survey_HearAboutSite_Internet_Meissen1: 'Website schloesserland-sachsen.de',
    Survey_HearAboutSite_Internet_Meissen2: 'Website albrechtsburg-meissen.de',
    Survey_HearAboutSite_Internet_Moritzburg: 'Website schloss-moritzburg.de',
    Survey_OtherOffers_Event_Moritzburg: 'Veranstaltung in Schloss Moritzburg',
    Survey_OtherOffers_Moritzburg:
      'andere Freizeiteinrichtungen hier in der Umgebung, z. B. Käthe Kollwitz-Gedenkstätte oder Fasanenschlösschen besuchen',
    Survey_VisitPrice_Low: 'Zu niedrig',
    Survey_HearAboutSite_Internet_OtherWebsites: 'Anderen Internetseiten',
    Survey_HearAboutSite_Instagram: 'Instagram',
    Survey_HearAboutSite_Facebook: 'Facebook',
    Survey_HearAboutSite_Magazines: 'Zeitungen/ Zeitschriften',
    Survey_HearAboutSite_AdvertisementMeissen: 'Plakate/ Anzeigen',
    Survey_HearAboutSite_Flyer2: 'Flyer/ Prospekte',
    Survey_HearAboutSite_TouristInformationsoffice: 'Touristinformation',
    Survey_HearAboutSite_Hotel: 'Unterkunft',
    Survey_HasImprovedVisit_YesGreat: 'Ja, sehr!',
    Survey_HasImprovedVisit_YesOk: 'Ja, zufriedenstellend',
    Survey_HearAboutSite_Advertisement: 'Werbung (Anzeige/Radio/Gutschein…)',
    Survey_HearAboutSite_FlyerAdvertisement: 'Flyer und Werbung (Plakat, Faltblatt)',
    Survey_Age_Category1: 'unter 14 Jahre',
    Survey_Age_Category2: '14-19 Jahre',
    Survey_Age_Category3: '20-29 Jahre',
    Survey_Age_Category4: '30-39 Jahre',
    Survey_Age_Category5: '40-49 Jahre',
    Survey_Age_Category6: '50-59 Jahre',
    Survey_Age_Category7: '60-69 Jahre',
    Survey_Age_Category8: '70+',
    Survey_Age_Category9: '14-18 Jahre',
    Survey_Age_Category10: '19-30 Jahre',
    Survey_Age_Category11: '31-45 Jahre',
    Survey_Age_Category12: '46-60 Jahre',
    Survey_Age_Category13: '60-70 Jahre',
    Survey_Age_Category14: '71-80 Jahre',
    Survey_Age_Category15: '81+',
    Survey_Age_Under18: 'unter 18 Jahre',
    '18–25': '18-25 Jahre',
    '26–41': '26–41 Jahre',
    '42–57': '42–57 Jahre',
    '58–67': '58–67 Jahre',
    '68–76': '68–76 Jahre',
    '77+': '77+ Jahre',
    PreferNotToAnswer: 'Prefer not to answer',
    Survey_HasImprovedVisit_NoImprovement: 'nein, keine Verbesserung',
    Survey_WillRecommend_Sure: 'ganz sicher',
    Survey_WillRecommend_MostlySure: 'wahrscheinlich ja',
    Survey_WillRecommend_DontKnow: 'weiß nicht',
    Survey_WillRecommend_MaybeNot: 'eher nicht',
    Survey_WillRecommend_NotAtAll: 'auf keinen Fall',
    Survey_OtherOffers_Gastronomy: 'Gastronomie',
    Survey_OtherOffers_GuidedTour: 'Führung',
    Survey_OtherOffers_Hiking: 'in der Umgebung spazieren, wandern',
    Survey_OtherOffers_RentANightAround: 'in der Umgebung übernachten',
    Survey_OtherOffers_Shopping: 'Shopping',
    Survey_OtherOffers_Others: 'Anderes',
    Survey_VisitPrice_VeryHappy: 'sehr zufrieden',
    Survey_VisitPrice_Happy: 'zufrieden',
    Survey_VisitPrice_Good: 'geht so',
    Survey_VisitPrice_NotMuchHappy: 'eher unzufrieden',
    Survey_VisitPrice_NotHappyAtAll: 'sehr unzufrieden',
    HistoricalCharacter: 'Historische Figur',
    HistoricalMonument: 'Historisches Monument, Weltkulturerbe',
    HistoricalEvent: 'Historisches Ereignis',
    Survey_ContinueOnline_YesNewXP: 'Ja, wenn es neue Erlebnisse gibt',
    Survey_ContinueOnline_YesWithoutXP: 'Ja, auch ohne neue Erlebnisse',
    Survey_HearAboutSite_Medias: 'Medien',
    Survey_HearAboutSite_SocialMedia: 'Soziale Netzwerke',
    Survey_HearAboutSite_Display: 'Plakatierung',
    Survey_HearAboutSite_Press: 'Presse',
    Survey_HearAboutSite_ResearchEngine: 'Suchmaschine',
    Survey_WithWhom_SoloSeul: 'allein',
    Survey_DresdenOffers_AudioGuide: 'Schlösserland-Audioguide für den Großer Garten',
    Survey_DresdenOffers_ParkRailway: 'Fahrt mit der Dresdner Parkeisenbahn',
    Survey_DresdenOffers_Gastronomie: 'Gastronomie im Großen Garten Dresden',
    Survey_DresdenOffers_HygieneMuseum: 'Besuch im Deutschen Hygiene-Museum Dresden',
    Survey_DresdenOffers_Zoo: 'Besuch im Zoo Dresden',
    Survey_DresdenOffers_Festung: 'Besuch in der Festung Xperience',
    Survey_DresdenOffers_Zwinger: 'Besuch in der Zwinger Xperience',
    Survey_DresdenOffers_Overnight: 'Übernachtung in der Umgebung',
    'Survey_HearAboutSite_Website_notredame-sachsen': 'Website notredame-dresden.de',
    YesLovedIt: 'Ja, es hat mir sehr gefallen!',
  },
  survey_questions: {
    Survey_Rating_WelcomeAccessibility: 'Empfang und Verfügbarkeit des Personals',
    Survey_Rating_PracticalInformations: 'nützliche Informationen',
    Survey_Rating_WaitingTime: 'Wartezeit',
    Survey_Rating_ComfortCleanliness: 'Komfort und Sauberkeit',
    Survey_Choice_VisitPrice: 'Wie würden Sie den Preis für die Besichtigung bewerten?',
    Survey_HistoPadUserFriendly_Question: 'Ist die Benutzung des HistoPad einfach?',
    Survey_OpenAnswer_WhatCanWeChange: 'Wenn nicht, was können wir ändern?',
    Survey_Age_Question: 'Wie alt sind Sie?',
    Survey_Origin_Question: 'Woher kommen Sie?',
    Survey_Origin_Pays: 'Aus welchem Land kommen Sie?',
    Survey_Origin_Departement: 'Aus welcher Region kommen Sie?',
    Survey_Origin_France: 'Woher kommen Sie?',
    Survey_FirstVisit_Question: 'Ist dies Ihr erster Besuch?',
    Survey_FirstVisitHere: 'Ist dies Ihr erster Besuch an diesem Ort?',
    Survey_WithWhom_Question: 'Sie haben besucht…',
    Survey_Rating_Signalitique: 'Ausschilderung und Informationen vor Ort',
    Survey_Rating_CafeChateau: 'Schlosscafé',
    Survey_Rating_PropreteMonument: 'Sauberkeit und Instandhaltung des Monuments',
    Survey_Rating_PropreteSanitaires: 'saubere sanitäre Einrichtungen',
    Survey_Rating_VisiteChapelle_Chateau: 'Visit of the chapel and the castle',
    Survey_Rating_VisiteJardins: 'Besuch der Gärten',
    Survey_Rating_NotesEnfants: 'Wie fanden Ihre Kinder die Besichtigung des Schlosses?',
    Survey_Reside_Question: 'Wo wohnen Sie während Ihres Aufenthaltes?',
    Survey_ResideHautesPyrenees_Question:
      'Where in Hautes-Pyrénées do you reside during your stay?',
    Survey_ResideHauteGaronne_Question: 'Where in Haute-Garonne do you reside during your stay?',
    Survey_Income_Question: 'What is your net monthly household income? ',
    Survey_Recommend_Question: 'Würden Sie die Besichtigung der Albrechtsburg empfehlen?',
    Survey_ExperienceRating_Question_CableCar:
      'Haben Sie den Aufzug benutzt, um auf den Burgberg zu gelangen?',
    Survey_ExperienceRating_Question_Panorama: 'The Panorama',
    Survey_ExperienceRating_Question_Ponton: 'The Pontoon in the Sky',
    Survey_ExperienceRating_Question_Animations: 'Animations',
    Survey_ExperienceRating_Question_EspaceExperiences: 'The Experimentation Area',
    Survey_ExperienceRating_Title: 'Did you enjoy your experience at the Pic du Midi?',
    Survey_Planetarium_Question: 'Did you attend a Planetarium session?',
    Survey_PlanetariumRating_Question: 'The Planetarium',
    Survey_PlanetariumRating_Title: 'Did you enjoy this Planetarium session?',
    Survey_SeanceCoupole_Question: 'Did you attend a Cupola session?',
    Survey_SeanceCoupoleRating_Question: 'The Cupola',
    Survey_SeanceCoupoleRating_Title: 'Did you enjoy this Cupola session?',
    Survey_HearAboutSite_Question: 'How did you hear about this museum?',
    Survey_HearAboutSite_Us: 'Wie sind Sie auf uns aufmerksam geworden?',
    Survey_Origin_ZIPCode: 'Wie lautet Ihre Postleitzahl?',
    Survey_HearAboutExhibit_Question: 'Wie haben Sie von dieser Ausstellung erfahren?',
    Survey_HearAboutExhibitInputField_Question:
      'Bitte erzählen Sie uns, wie Sie von dieser Ausstellung erfahren haben.',
    Survey_VisitExhibitPrimaryReason_Question:
      'War der Besuch dieser Ausstellung der Hauptgrund für Ihr Kommen heute?',
    Survey_Gender_Question: 'Sind Sie männlich oder weiblich?',
    Survey_GroupSize_Question: 'Wie viele Besucher umfasste Ihre Gruppe?',
    Survey_RentingPrice_Question: 'How would you rate the price for renting the HistoPad?',
    Survey_HistopadEaseOfUse_Question: 'Nutzerfreundlichkeit des Tablets',
    Survey_HistopadContentQuality_Question: 'Inhaltliche Qualität des Tablets',
    Survey_HistopadOverallExperience_Question: 'Erfahrung insgesamt mit dem Tablet',
    Survey_ExhibitNavigation_Question: 'einfache Navigation anzeigen',
    Survey_ExhibitPanelContent_Question: 'Qualität des Panelinhaltes',
    Survey_ExhibitOverallExperience_Question: 'Gesamterfahrung bewerten',
    Survey_Rating_Boarding: 'Boarding',
    Survey_Rating_Itinerary: 'Vorgeschlagene Route',
    Survey_Rating_AudioContent: 'Audiokommentar',
    Survey_Rating_InteractiveXP: 'interaktive Erfahrungen',
    Survey_VisitPrice_Question: 'Wie würden Sie den Eintrittspreis bewerten?',
    Survey_FirstVisit_Question_Paris: 'Ist dies Ihr erster Besuch in Meißen?',
    Survey_Rating_Welcome: 'Gastfreundschaft',
    Survey_Rating_TipStart: 'Hinweise für den Start',
    Survey_Rating_ComfortVisit: 'Besucherkomfort',
    Survey_Rating_Orientation: 'Orientierung im Schloss',
    Survey_VisitPrice_Question_CastleHistoPad:
      'Wie würden Sie den Eintrittspreis (Schloss + HistoPad) bewerten?',
    Survey_Decide_Question: 'Was ist der Grund Ihres Besuchs?',
    Survey_Coming_Question: 'Have you come... ',
    Survey_Origin_GermanLand: 'Bundesland',
    Survey_VisitPrice_Question_Meissen: 'Wie schätzen Sie den Eintrittspreis ein?',
    Survey_HasImprovedVisit_Question: 'Hat Histopad Ihren Besuch verbessert?',
    Survey_WillRecommend: 'Werden Sie Ihren Besucher weiteremfpehlen?',
    Survey_SaySomethingMore: 'Haben Sie noch Hinweise für uns?',
    Survey_Rating_Signage: 'Steckbrief',
    Survey_Bookstore: 'Buchhandlung-Boutique (Empfehlung und Auswahl)',
    Survey_HearAboutSiteInputField_Question: 'Wie haben Sie von diesem Museum erfahren?',
    Survey_RestaurantSaline: 'Restaurant "La Table des Jardins"',
    Survey_Age_Question_Categories: 'Zu welcher Altersgruppe gehören Sie?',
    Survey_OtherOffers_Question: 'Welche Angebote nutzen Sie noch? (Mehrfachangaben möglich)',
    Survey_VisitPrice_QuestionVariant: 'Wie zufrieden sind Sie mit dem Preis-/Leistungsverhältnis?',
    Survey_HearAboutSite_UsSeveralChoices:
      'Wie sind Sie auf uns aufmerksam geworden? (Mehrfachangaben möglich)',
    Survey_Rating_StaffAmability: 'Der Freundlichkeit des Personals?',
    Survey_Rating_StaffCompetence: 'Der Kompetenz des Personals?',
    Survey_HistoPadUserFriendly_WhatCanWeChange: 'Falls nicht, was kann man verbessern?',
    Survey_OtherSites_Question: 'Würden Sie gerne weitere Monumente mit dem Histopad entdecken?',
    Survey_OtherExhibits_Question:
      'Würden Sie gerne mehr Ausstellungen/Exponate wie diese im Museum sehen?',
    Survey_ExperienceWas_Ludic: 'Fanden Sie Ihr Besuchserlebnis … Unterhaltsam',
    Survey_ExperienceWas_Pedagogic: 'Fanden Sie Ihr Besuchserlebnis … Lehrreich',
    Survey_ExperienceWas_Immersive: 'Fanden Sie Ihr Besuchserlebnis … Immersiv',
    Survey_WillRecommend_AugmentedExhibits:
      'Würden Sie diese erweiterte, digitale Besichtigung weiterempfehlen?',
    Survey_OtherAugmentedExhibits_question:
      'Würden Sie gerne eine andere erweiterte digitale Ausstellung mit dem HistoPad besuchen?',
    Survey_IfYesWhichSubject: 'Wenn ja, zu welchem Thema?',
    Survey_WouldYouPay_AugmentedExhibits:
      'Wären Sie bereit, für diese erweiterte digitale Ausstellung zu bezahlen?',
    Survey_IfYesHowMuch: 'Wenn ja, wie viel?',
    Survey_ContinueOnline_Question: 'Möchten Sie dieses Erlebnis zu Hause online fortsetzen?',
    Survey_HistoPadFirstTime: 'Ist dies das erste Mal, dass Sie ein HistoPad verwenden?',
    Survey_HearAboutSite_AugmentedExhibit:
      'Wie haben Sie von dieser erweiterten digitalen Ausstellung erfahren?',
    Survey_OtherAugmentedExhibits_OrPlace_question:
      'Würden Sie gern eine andere Ausstellung oder einen anderen Ort mit dem HistoPad besuchen?',
    Survey_GrossenGarten_Dresden: 'Ist dies Ihr erster Besuch im Palais im Großen Garten Dresden?',
    Survey_OtherOffers_Question_long:
      'Welche Angebote haben Sie heute bereits genutzt oder werden Sie noch nutzen?',
    Survey_Impression_captivating: 'Mitreißend',
    Survey_Rating_StaffWelcomeAvailability: 'Dem Empfang und der Verfügbarkeit des Personals?',
    Survey_VisitPrice_Ratio: 'Dem Preis-Leistungs-Verhältnis',
    Survey_Rating_SignageInsideCity: 'Der Beschilderung (innen/in der Stadt)',
    Survey_Bookstore_AdviceChoice: 'Shop (Empfehlung und Auswahl)',
    Survey_Rating_VisitContent: 'Dem Inhalt der Besichtigung',
    Survey_Rating_OpeningHoursMHAB: 'Öffnungszeiten des MHAB',
    Survey_HearAboutSite_MHAB: 'Wie haben Sie vom MHAB erfahren?',
    Survey_WillRecommend_MHAB: 'Würden Sie den Besuch des MHAB weiterempfehlen?',
    Survey_Net_Promoter_Score: 'Net promoter score',
  },
}
